import React from 'react';

const ArrowRight = ({ ...props }) => (
  <svg {...props} width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 9L1.99999 18L0.73999 16.74L8.47999 9L0.73999 1.26L1.99999 0L11 9Z" fill="#2196F3" />
  </svg>
);

export default ArrowRight;
